module.exports = __webpack_public_path__ + "img/hclips.c3c355e.png";